import React, { FC } from 'react'
import styles from 'styles/components/typography.module.scss'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { RequiredLabel } from 'components/Label'

type Props = {
  iconPath?: string
  label: string
  required?: boolean
}

const SmallHeadline: FC<Props> = React.memo((props) => {
  const { iconPath, label, required } = props
  return (
    <FlexRow justifyContent={'start'}>
      {iconPath && (
        <>
          <img src={iconPath} alt={`${label}のアイコン`} />
          <Spacer size={4} axis={'horizontal'} />
        </>
      )}
      <h4 className={styles.headline_small}>{label}</h4>
      {required && (
        <>
          <Spacer size={4} axis={'horizontal'} />
          <RequiredLabel />
        </>
      )}
    </FlexRow>
  )
})

export default SmallHeadline
